'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.livePricingOnEnter = exports.pricingOnEnter = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _selectors = require('redux/saga/selectors');

var _helpers = require('redux/saga/helpers');

var _deep = require('helpers/deep');

var _locale = require('redux/modules/locale');

var _requireFeature = require('routes/helpers/requireFeature');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pricingOnEnter = /*#__PURE__*/exports.pricingOnEnter = _regenerator2.default.mark(function pricingOnEnter(client, nextState, replaceState) {
  var profile, status, location, params;
  return _regenerator2.default.wrap(function pricingOnEnter$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          if (_context.sent) {
            _context.next = 4;
            break;
          }

          return _context.abrupt('return');

        case 4:
          _context.next = 6;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 6:
          profile = _context.sent;
          status = (0, _deep.deepExtract)('membership.status', profile, '');
          location = nextState.location, params = nextState.params;

          if (!(status === 'active')) {
            _context.next = 17;
            break;
          }

          if (!(location.pathname.indexOf('/pricing/live') > -1)) {
            _context.next = 14;
            break;
          }

          _context.next = 13;
          return (0, _effects.call)(replaceState, '/settings/live/' + (params.planType || 'plans'));

        case 13:
          return _context.abrupt('return', _context.sent);

        case 14:
          _context.next = 16;
          return (0, _effects.call)(replaceState, '/classes');

        case 16:
          return _context.abrupt('return', _context.sent);

        case 17:
        case 'end':
          return _context.stop();
      }
    }
  }, pricingOnEnter, this);
});

var livePricingOnEnter = /*#__PURE__*/exports.livePricingOnEnter = _regenerator2.default.mark(function livePricingOnEnter(client, nextState, replaceState) {
  var params, country, msa, list, outsideUSA;
  return _regenerator2.default.wrap(function livePricingOnEnter$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          params = nextState.params;
          _context2.next = 3;
          return (0, _effects.call)(_helpers.scrollToTop);

        case 3:
          if (!(params.planType === 'trial')) {
            _context2.next = 6;
            break;
          }

          _context2.next = 6;
          return (0, _effects.call)(_requireFeature.requireFeatureSaga, client, replaceState, 'classpass_live_trial', '/live');

        case 6:
          _context2.next = 8;
          return (0, _effects.select)(_locale.selectCountry);

        case 8:
          country = _context2.sent;

          if (!(country !== 'USA')) {
            _context2.next = 13;
            break;
          }

          _context2.next = 12;
          return (0, _effects.call)(replaceState, '/live/waitlist');

        case 12:
          return _context2.abrupt('return', _context2.sent);

        case 13:
          _context2.next = 15;
          return (0, _effects.call)(_helpers.geodetectMsa, client);

        case 15:
          msa = _context2.sent;

          if (msa) {
            _context2.next = 18;
            break;
          }

          return _context2.abrupt('return');

        case 18:
          _context2.next = 20;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msas, [client]);

        case 20:
          list = _context2.sent;
          outsideUSA = list.reduce(function (acc, item) {
            return acc || item.id === msa.id && item.country_code !== 'USA';
          }, false);

          if (!outsideUSA) {
            _context2.next = 26;
            break;
          }

          _context2.next = 25;
          return (0, _effects.call)(replaceState, '/live/waitlist');

        case 25:
          return _context2.abrupt('return', _context2.sent);

        case 26:
        case 'end':
          return _context2.stop();
      }
    }
  }, livePricingOnEnter, this);
});